import { Component, OnDestroy, OnInit } from '@angular/core';
import {
    ArmService,
    AuthenticationService,
    DossierMedicalService,
    EspaceClientService,
    User,
} from '@kv-common-components/kx-services';
import { I18nPipe } from '@shared/pipes/i18n.pipe';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-appointment-type',
    templateUrl: 'appointment-type.component.html',
})
export class AppointmentTypeComponent implements OnInit, OnDestroy {
    isLoading = true;
    currentUser: User;
    currentEspaceClient: any;
    showModalVerification = false;
    phoneCallBackInformation = '';
    idDossierMedical: any;

    espaceClientSubscription: Subscription;

    constructor(
        private authService: AuthenticationService,
        private espaceCltService: EspaceClientService,
        private i18nPipe: I18nPipe,
        private armService: ArmService,
        private dossierMedical: DossierMedicalService,
        private router: Router
    ) {}

    ngOnInit(): void {
        this.currentUser = this.authService.currentUserValue;
        this.espaceClientSubscription =
            this.espaceCltService.currentEspaceClient.subscribe((response) => {
                this.currentEspaceClient = response;
                const idDossier = String(
                    this.authService.currentUserValue.idDossier
                );
                const idAia = String(this.currentEspaceClient.personne.idAia);
                this.dossierMedical
                    .getIdDossierMedical(idAia, idDossier)
                    .subscribe((resultDossierMedical) => {
                        this.idDossierMedical =
                            resultDossierMedical.idDossierMedical;
                    });
                this.buildCallBackInformation();
                this.isLoading = false;
            });
    }

    ngOnDestroy() {
        if (this.espaceClientSubscription) {
            this.espaceClientSubscription.unsubscribe();
        }
    }

    openModalVerification() {
        this.showModalVerification = true;
    }

    closeModal() {
        this.showModalVerification = false;
    }

    confirmInformation() {
        this.armService
            .postWebCallBack(this.idDossierMedical, null)
            .subscribe((success) => {
                this.router.navigateByUrl(
                    '/souscription/document-medicale/document-list'
                );
            });
        this.showModalVerification = false;
    }

    buildCallBackInformation() {
        const modalCallBackBody = this.i18nPipe.transform(
            'appointment.appointment-type.modal.phone.confirmation'
        );
        const phoneNumer = this.buildPhoneNumer(
            this.currentEspaceClient.personne.telephone
        );
        this.phoneCallBackInformation = modalCallBackBody.replace(
            '%s',
            phoneNumer
        );
    }

    buildPhoneNumer(telephone) {
        const matchRegex = telephone.match(/(\d{2})(\d{6})(\d{2})/);
        telephone = telephone.replace(matchRegex[2], ' ** ** ** ');
        telephone = '<span class="phone phone--green">' + telephone + '</span>';
        return telephone;
    }
}
